import React, { Fragment, useState } from 'react';
import  { FormattedMessage } from 'react-intl';
import DOMPurify from 'dompurify';
import { dateMethods } from '@utils/dates/dateMethods';
import htmlDecode from '@utils/miscellaneous/decodeHTMLString';
import dynamicSpacingOfString from '@utils/tools/dynamicSpacingOfString';
import { FORMATTED_DATES } from '@constants/individualPortal/dashboard/dashboardModelTypes';
import { GIButton } from 'app-components';
import { createObjectWrapper } from '@utils/miscellaneous/objectHelpers';



const CommentList = ( { props } ) => {
    const [newComment, setNewComment] = useState('');
    const { postCommentHandler, commentData, tData } = props.props;

    const handleChange =  (e) => {
        setNewComment(e.target.value);
    };

    return(
        <Fragment>
            <div className='ticket-header-styled'>
                <h3 className='heading'>
                    <FormattedMessage id='ticket.detail.header.comment'/>
                </h3>
            </div>
            { commentData && commentData.length > 0 &&
            <div className='grid-container comment-container'>
                {
                    createObjectWrapper(commentData).map(item => {
                        return (
                            <CommentItem className='grid-col-12' key={item.id} comment={item}/>
                        );
                    }).valueOf()
                }
            </div>
            }
            { (tData.status !== 'Resolved' && tData.status !== 'Canceled') ?
                <div className='grid-fluid-container'>
                    <div className='grid-row'>
                        <form className='grid-col-12'>
                            <textarea className='usa-textarea-comment' id='adding-comment' aria-label="add comment" value={newComment} onChange={handleChange} name='newComment'/>
                            <GIButton
                                id="btn_post_comment"
                                type="button"
                                labelId='btn_post_comment'
                                className="usa-button gi-button gi-button__primary"
                                onClickHandler={ () => postCommentHandler(DOMPurify.sanitize(newComment), setNewComment) }
                            />
                        </form>
                    </div>
                </div> : null
            }

        </Fragment>
    );

};

const CommentItem = ({ comment }) => { //({ comment })
    const { getFormattedDate } = dateMethods;
    const firstName = comment.commenterName.split(' ')[0];
    let commentText;
    let hasSpace = false;
    
    if (comment.comment.indexOf('&#xa;') !== -1) {
        hasSpace = true;
        commentText = dynamicSpacingOfString(comment.comment, '&#xa;');
    } else {
        commentText = comment.comment ? htmlDecode(comment.comment) : ' ';
    }

    return (
        <div className='comment-detail'>
            <strong className='comment-header' data-automation-id='content_ticket_comment_header'>
                <FormattedMessage id='comment.header' values={{ author: firstName, date: getFormattedDate(FORMATTED_DATES.commentMonthHour, comment.created) }}/>
            </strong>
            {  hasSpace && commentText.length ?
                commentText.map((mappedComment, ind) => { return ( <p className='comment-content' key={`${comment.id}-comment-${ind}`} data-automation-id='content_ticket_user_comments' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(mappedComment) }}></p> ); })
                : <p className='comment-content' key={`${comment.id}-comment`} data-automation-id='content_ticket_user_comments' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(commentText) }}></p>
            }

        </div>
    );
};

export default CommentList;